import type { SVGProps } from 'react'
const SvgSyChevronRightSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m7.4 23.1-2-2 9.1-9.1-9-9.1 2-2L18.6 12 7.5 23.1z" />
	</svg>
)
export default SvgSyChevronRightSystem
